import { render, staticRenderFns } from "./reviewApplyRoomDiscount.vue?vue&type=template&id=0b45c098&scoped=true"
import script from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./reviewApplyRoomDiscount.vue?vue&type=style&index=0&id=0b45c098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45c098",
  null
  
)

export default component.exports